export default __webpack_public_path__ + "static/media/87_desktop.d498d5fe.jpg";